import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';

import { provideTellentContextCollector } from '@core/tellent-assistant-contracts';
import {
  provideTellentAssistantAuthTokenGetter,
  provideTellentAssistantEndpoint,
  provideTellentAssistantThreadsBaseUrl,
} from '@core/tellent-assistant-data';
import { DialogContextCollector, RouteContextCollector } from '@core/tellent-assistant-logic';

export interface TellentAssistantOptions {
  endpoint: string;
  authTokenGetter: () => string | null;
  threadsBaseUrl?: string;
  extraProviders?: Provider[];
}

export function provideTellentAssistant(opts: TellentAssistantOptions): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTellentAssistantEndpoint({ useValue: opts.endpoint }),
    provideTellentAssistantAuthTokenGetter({ useValue: opts.authTokenGetter }),
    ...(opts.threadsBaseUrl
      ? [provideTellentAssistantThreadsBaseUrl({ useValue: opts.threadsBaseUrl })]
      : []),
    provideTellentContextCollector({ useExisting: RouteContextCollector }),
    provideTellentContextCollector({ useExisting: DialogContextCollector }),
    ...(opts.extraProviders ?? []),
  ]);
}
